import { useMemo } from 'react';

import { useSparkplugAccount } from './SparkplugAccountsHooks/SparkplugAccountsHooks';

// Hardcoded account IDs that should never see upgrade modals in production
const HIDDEN_ACCOUNT_IDS = ['6581df31c243fe00129b92a6', '65779f4b2d8d0d0013d825af']; // Luisa QA Store and Luisa QA Vendor

/**
 * Custom hook to determine if upgrade modals should be hidden for specific accounts in production
 */
export const useHideUpgradeModal = () => {
    const { account } = useSparkplugAccount();

    const isProduction = import.meta.env.REACT_APP_ENV === 'prod';

    const shouldHideUpgradeModal = Boolean(
        isProduction && account?._id && HIDDEN_ACCOUNT_IDS.includes(account._id),
    );

    /**
     * Get the effective visibility for a modal, taking into account the hide logic
     * @param {boolean} intendedVisibility - The originally intended visibility state
     * @returns {boolean} - The effective visibility after applying hide logic
     */
    const getEffectiveVisibility = (intendedVisibility: boolean): boolean => {
        return shouldHideUpgradeModal ? false : intendedVisibility;
    };

    return {
        shouldHideUpgradeModal,
        getEffectiveVisibility,
    };
};
